import type { Lang } from '@/i18n/translations'

/** Both hash items ('#faq') and path items ('/blog') just get the current-language prefix ('/bs#faq', '/bs/blog'). */
export function resolveNavHref(href: string, lang: Lang): string {
  return `/${lang}${href}`
}
